import { StyleSheet, Platform } from 'react-native'
import type { Theme } from '../../../theme/getTheme'

export function getAccountAdminStartHerePanelStyles(theme: Theme) {
  return StyleSheet.create({
    scrollView: {
      flex: 1,
      ...(Platform.OS === 'web' && {
        minHeight: 0 as never,
      }),
    },
    scroll: {
      flexGrow: 1,
      paddingTop: theme.spacing.md,
      paddingBottom: theme.spacing.huge,
    },
    /** Same vertical padding as `scroll` without flexGrow (site web outer ScrollView). */
    scrollPlain: {
      paddingTop: theme.spacing.md,
      paddingBottom: theme.spacing.huge,
    },
    embeddedBody: {
      width: '100%',
      alignSelf: 'stretch',
    },
    title: {
      fontSize: 20,
      fontWeight: '800',
      color: theme.gray[900],
      marginBottom: theme.spacing.xl,
    },
    intro: {
      fontSize: 15,
      color: theme.gray[600],
      lineHeight: 24,
      marginBottom: theme.spacing.huge,
    },
    guideTitle: {
      fontSize: 16,
      fontWeight: '800',
      color: theme.gray[900],
      marginBottom: theme.spacing.xl,
    },
    stepRow: {
      marginBottom: theme.spacing.xxl,
      paddingLeft: theme.spacing.xxxl,
      borderLeftWidth: 3,
      borderLeftColor: theme.primary,
    },
    stepRowLast: {
      paddingLeft: theme.spacing.xxxl,
      borderLeftWidth: 3,
      borderLeftColor: theme.primary,
    },
    stepText: {
      fontSize: 15,
      color: theme.gray[600],
      lineHeight: 24,
    },
    stepLink: {
      fontSize: 15,
      lineHeight: 24,
      color: theme.primary,
      fontWeight: '600',
      textDecorationLine: 'underline',
      ...(Platform.OS === 'web' && {
        cursor: 'pointer' as never,
      }),
    },
    stepLinkPressed: {
      opacity: 0.75,
    },
  })
}
